export const HOME_WIDGET_FETCH_DELAYS = Object.freeze({
  toDo: 1000,
  routines: 2000,
  activityBoard: 3000,
})
